import styles from "./HistoryDialog.mobile.module.css";
import DialogView from "../../dialog/Dialog.view";
import { useTranslation } from "react-i18next";
import { parseStringToDate } from "../../../tools/converters/DateConverter";
import type HistoryDialogProperties from "../HistoryDialog.properties.ts";
import { useHistoryDialog } from "../HistoryDialog.controller.ts";
import React from "react";

export default function HistoryDialogMobileView(
  props: HistoryDialogProperties,
) {
  const { t } = useTranslation();
  const { histories, page, totalPage, previous, next } =
    useHistoryDialog(props);

  return (
    <DialogView
      header={props.name}
      moveToFront
      onBackdrop={props.handleDialogCloseClick}
    >
      <>
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead className={styles.thead}>
              <tr>
                {props.showMarketComponentName && (
                  <th className={styles.th}>{t("ui.marketComponentName")}</th>
                )}
                <th className={styles.th}>{t("ui.date")}</th>
                <th className={styles.th}>{t("ui.criticalDate")}</th>
                <th className={styles.th}>{t("ui.user")}</th>
              </tr>
            </thead>
            <tbody>
              {histories.map((historyDetails, index) => (
                <tr key={index}>
                  {props.showMarketComponentName && (
                    <td className={styles.tdDate}>
                      {historyDetails.marketComponentName}
                    </td>
                  )}
                  <td className={styles.tdDate}>
                    {parseStringToDate(historyDetails.date, t)}
                  </td>
                  <td className={styles.tdDate}>
                    {historyDetails.criticalDate &&
                      parseStringToDate(historyDetails.criticalDate, t, false)}
                  </td>
                  <td className={styles.tdUser}>{historyDetails.username}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className={styles.pageContainer}>
          <span className={styles.navigation} onClick={previous}>
            {t("ui.previous")}
          </span>
          <span>
            {t("ui.page")} {page} / {totalPage}
          </span>
          <span className={styles.navigation} onClick={next}>
            {t("ui.next")}
          </span>
        </div>
      </>
    </DialogView>
  );
}
